"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgentEditFeeEditor = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const __1 = require("..");
const Field_1 = require("../../../Form/Field");
const utils_1 = require("../utils");
const AgentEditFeeEditor = (props) => {
    const { fields } = props;
    if (fields.monthlyFee.hidden)
        return null;
    return (react_1.default.createElement("div", { className: `${__1.className}__field` },
        react_1.default.createElement(Field_1.FormField, { addon: 'CHF', label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Agent/Edit:MonthlyFee', defaultMessage: 'Monthly fee' }), name: 'monthlyFee', error: fields.monthlyFee.error, value: (0, utils_1.wrapNumericValue)(fields.monthlyFee.value), onChange: (0, utils_1.wrapNumericOnEvent)(fields.monthlyFee.onEvent), modificators: fields.monthlyFee.modifiers, disabled: fields.monthlyFee.disabled })));
};
exports.AgentEditFeeEditor = AgentEditFeeEditor;
//# sourceMappingURL=fee.js.map